import anime from 'animejs';
import 'waypoints/lib/noframework.waypoints.min.js';

const swooshCollections = [...document.querySelectorAll('.js-swooshCollection')];

swooshCollections.forEach(function applyfadeInEffect(swooshCollection) {
  const swooshItems = swooshCollection.querySelectorAll('.js-swooshItem');
  const collectionHeight = swooshCollection.offsetHeight;

  const fadeIn = anime({
    targets: swooshItems,
    keyframes: [{ scale: 1.3, opacity: 0 }, { scale: 1, opacity: 1 }],
    duration: 1000,
    delay: anime.stagger(50),
    easing: 'easeOutQuint',
    autoplay: false,
  });

  const waypoint = new Waypoint({
    element: swooshCollection,
    offset: collectionHeight > 800 ? '75%' : 'bottom-in-view',
    handler() {
      fadeIn.play();
      waypoint.destroy();
    },
  });
});
